// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25MPT","right":"styles_right__2AYDY"};